export enum SuppliesReorderTriggerType {
  InitialSetup = "initial_setup",
  InventoryThreshold = "inventory_threshold",
  OneTimePurchase = "one_time_purchase",
}
